module.exports = __webpack_public_path__ + "static/img/eSPL.b8070411.png";